// extracted by mini-css-extract-plugin
var _1 = "container-XhclU";
export { _1 as "container" }
